import React from 'react';

export default function MicrophoneDemo({ visible }) {
  if (!visible) return null;

  return (
    <div
      className="anim-mic-in"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
      }}
    >
      {/* Pulsing ring */}
      <div style={{position:'relative', display:'flex', alignItems:'center', justifyContent:'center'}}>
        <div style={{
          position: 'absolute',
          width: 110,
          height: 110,
          borderRadius: '50%',
          background: 'rgba(255,200,0,0.25)',
          animation: 'mic-ring 1.1s ease-in-out infinite',
        }}/>
        <div style={{
          position: 'absolute',
          width: 90,
          height: 90,
          borderRadius: '50%',
          background: 'rgba(255,200,0,0.2)',
          animation: 'mic-ring 1.1s ease-in-out infinite 0.2s',
        }}/>

        {/* Mic button */}
        <div
          className="anim-mic-ring"
          style={{
            width: 72,
            height: 72,
            borderRadius: '50%',
            background: '#FFD600',
            border: '5px solid #111',
            boxShadow: '4px 4px 0 #111',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'relative',
            zIndex: 1,
          }}
        >
          <MicSVG/>
        </div>
      </div>

      <p style={{
        fontFamily: "'Fredoka One', cursive",
        fontSize: '1.5rem',
        color: '#111',
        margin: 0,
        textShadow: '2px 2px 0 #FFD600',
      }}>
        Your turn! 🎤
      </p>
    </div>
  );
}

function MicSVG() {
  return (
    <svg viewBox="0 0 40 50" width="36" height="44" xmlns="http://www.w3.org/2000/svg">
      {/* Mic body */}
      <rect x="13" y="2" width="14" height="22" rx="7" fill="#111"/>
      {/* Mic stand arc */}
      <path d="M7 22 Q7 36 20 36 Q33 36 33 22" fill="none" stroke="#111" strokeWidth="3.5" strokeLinecap="round"/>
      {/* Stand post */}
      <line x1="20" y1="36" x2="20" y2="46" stroke="#111" strokeWidth="3.5" strokeLinecap="round"/>
      {/* Base */}
      <line x1="12" y1="46" x2="28" y2="46" stroke="#111" strokeWidth="3.5" strokeLinecap="round"/>
    </svg>
  );
}
